var _filter;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 44,
    viewBox: "0 0 77 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4459_13228)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4459_13228)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.4082,
    y: 0.5,
    width: 72.4958,
    height: 24.76,
    rx: 12.38,
    transform: "rotate(15 6.4082 0.5)",
    fill: "url(#paint0_linear_4459_13228)",
    style: {}
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4644 25.6569C60.0362 25.8101 60.4812 26.066 60.7992 26.4245C61.125 26.7851 61.3303 27.2087 61.4153 27.6953C61.508 28.1839 61.4839 28.691 61.3431 29.2164L60.5418 32.2069L59.3943 31.8995L60.1459 29.0944C60.2391 28.7467 60.2671 28.4105 60.2298 28.0858C60.2003 27.7631 60.0896 27.4809 59.8977 27.239C59.7135 26.9991 59.4437 26.8316 59.0882 26.7363C58.7482 26.6452 58.4385 26.6575 58.159 26.7731C57.8816 26.881 57.6457 27.0662 57.4511 27.3288C57.2585 27.5836 57.1157 27.8849 57.0225 28.2327L56.2647 31.0609L55.1172 30.7534L55.875 27.9252C55.9682 27.5775 55.9951 27.2451 55.9558 26.9281C55.9263 26.6055 55.8146 26.3271 55.6206 26.0929C55.4364 25.8531 55.1665 25.6855 54.8111 25.5903C54.4556 25.495 54.1382 25.5052 53.8587 25.6208C53.587 25.7385 53.3577 25.9297 53.1708 26.1943C52.984 26.459 52.844 26.7652 52.7508 27.1129L51.9992 29.918L50.8517 29.6105L51.6499 26.6316C51.7927 26.0984 52.0187 25.6413 52.3279 25.2603C52.6447 24.8814 53.0305 24.6162 53.4852 24.4647C53.9476 24.3153 54.4609 24.3162 55.025 24.4674C55.5041 24.5957 55.8927 24.7992 56.1907 25.0779C56.4965 25.3586 56.7025 25.6871 56.8087 26.0634C56.9226 26.4418 56.9265 26.8445 56.8204 27.2716L56.5654 27.2033C56.6947 26.7824 56.8995 26.4356 57.1796 26.1628C57.4675 25.8921 57.8063 25.7095 58.196 25.6152C58.5934 25.5229 59.0162 25.5368 59.4644 25.6569Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1335 27.5707C47.4889 27.6659 47.8102 27.6568 48.0974 27.5432C48.3944 27.424 48.6451 27.2303 48.8495 26.9621C49.0538 26.6938 49.2026 26.3858 49.2958 26.0381L50.0288 23.3026L51.1763 23.6101L50.406 26.4847C50.259 27.0333 50.0173 27.5027 49.6808 27.893C49.3465 28.2754 48.9354 28.5422 48.4477 28.6931C47.9678 28.8461 47.4303 28.8428 46.8353 28.6834C46.248 28.5261 45.7848 28.2611 45.4456 27.8887C45.1086 27.5085 44.8908 27.0691 44.7925 26.5707C44.6962 26.0645 44.7216 25.5371 44.8686 24.9885L45.6357 22.1255L46.7833 22.433L46.0472 25.1801C45.9561 25.5201 45.932 25.8573 45.9749 26.1918C46.0177 26.5263 46.1341 26.8184 46.324 27.068C46.5159 27.3099 46.7857 27.4775 47.1335 27.5707Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0711 21.4381L44.2186 21.7455L42.6967 27.4252L41.5492 27.1177L43.0711 21.4381ZM43.9403 20.4659C43.8089 20.4307 43.6936 20.3667 43.5942 20.2738C43.497 20.1732 43.4291 20.0556 43.3906 19.9211C43.3521 19.7865 43.3515 19.6497 43.3888 19.5106C43.426 19.3715 43.495 19.2533 43.5956 19.1561C43.6962 19.0588 43.8138 18.9909 43.9483 18.9524C44.0829 18.9139 44.2158 18.9123 44.3472 18.9475C44.4863 18.9848 44.6006 19.0527 44.6901 19.1512C44.7874 19.2518 44.8514 19.3683 44.8822 19.5008C44.9207 19.6354 44.9213 19.7722 44.884 19.9113C44.8467 20.0504 44.7778 20.1685 44.6772 20.2658C44.5843 20.3652 44.4706 20.4341 44.3361 20.4726C44.2113 20.5054 44.0794 20.5032 43.9403 20.4659Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0049 20.175C39.5767 20.3282 40.0217 20.5841 40.3397 20.9426C40.6655 21.3032 40.8709 21.7268 40.9558 22.2134C41.0485 22.702 41.0245 23.209 40.8837 23.7345L40.0824 26.725L38.9348 26.4175L39.6864 23.6125C39.7796 23.2648 39.8076 22.9285 39.7704 22.6038C39.7409 22.2812 39.6301 21.9989 39.4382 21.757C39.254 21.5172 38.9842 21.3496 38.6287 21.2544C38.2887 21.1633 37.979 21.1755 37.6995 21.2911C37.4222 21.399 37.1862 21.5843 36.9916 21.8468C36.7991 22.1017 36.6562 22.403 36.5631 22.7507L35.8052 25.579L34.6577 25.2715L35.4155 22.4433C35.5087 22.0955 35.5356 21.7632 35.4963 21.4462C35.4668 21.1236 35.3551 20.8452 35.1611 20.611C34.9769 20.3711 34.7071 20.2036 34.3516 20.1083C33.9961 20.0131 33.6787 20.0233 33.3992 20.1389C33.1275 20.2566 32.8982 20.4477 32.7114 20.7124C32.5245 20.977 32.3845 21.2832 32.2913 21.631L31.5397 24.436L30.3922 24.1285L31.1904 21.1496C31.3332 20.6164 31.5593 20.1594 31.8684 19.7784C32.1853 19.3995 32.571 19.1343 33.0257 18.9828C33.4882 18.8334 34.0014 18.8343 34.5655 18.9854C35.0446 19.1138 35.4332 19.3173 35.7312 19.5959C36.037 19.8766 36.243 20.2052 36.3492 20.5815C36.4632 20.9599 36.4671 21.3626 36.3609 21.7897L36.1059 21.7213C36.2352 21.3005 36.44 20.9536 36.7201 20.6809C37.008 20.4101 37.3468 20.2276 37.7365 20.1333C38.1339 20.041 38.5567 20.0549 39.0049 20.175Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7511 23.2896C26.1793 23.1364 25.6996 22.8712 25.312 22.4941C24.9265 22.1092 24.6624 21.6574 24.5197 21.1388C24.3792 20.6125 24.3865 20.0596 24.5418 19.48C24.6868 18.9391 24.9391 18.4766 25.2987 18.0926C25.6604 17.7009 26.0928 17.4317 26.596 17.2849C27.1012 17.1304 27.6397 17.1297 28.2115 17.2829C28.7833 17.4362 29.2399 17.6951 29.5811 18.0599C29.9321 18.419 30.1617 18.8449 30.2698 19.3377C30.3878 19.8248 30.3764 20.3311 30.2356 20.8566L30.1113 21.3202L25.3474 20.0437L25.6802 19.636C25.5494 20.0316 25.5188 20.4085 25.5885 20.7668C25.6581 21.125 25.8139 21.44 26.0558 21.7119C26.2997 21.976 26.6187 22.1609 27.0128 22.2665C27.3683 22.3618 27.7097 22.3704 28.037 22.2925C28.3721 22.2166 28.666 22.0469 28.9188 21.7834L29.6786 22.4714C29.3009 22.892 28.8576 23.1708 28.3488 23.3078C27.8401 23.4448 27.3075 23.4387 26.7511 23.2896ZM25.8127 19.3733L29.1626 20.2709C29.2279 19.9654 29.2182 19.6771 29.1335 19.4059C29.0565 19.1368 28.9109 18.9073 28.6968 18.7174C28.4904 18.5296 28.2326 18.3943 27.9235 18.3114C27.6067 18.2266 27.307 18.2167 27.0245 18.2818C26.7498 18.3489 26.508 18.4788 26.299 18.6713C26.0978 18.8658 25.9357 19.0998 25.8127 19.3733Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5409 21.7568L20.3934 21.4494L21.3003 18.0648C21.4245 17.6011 21.6203 17.2105 21.8876 16.8928C22.1627 16.5773 22.4943 16.3597 22.8824 16.2401C23.2784 16.1225 23.7236 16.13 24.2181 16.2626C24.4036 16.3122 24.5762 16.3792 24.7358 16.4634C24.9053 16.5419 25.0541 16.6356 25.1823 16.7445L24.8779 17.8804C24.7616 17.7582 24.6275 17.656 24.4755 17.5738C24.3313 17.4938 24.182 17.4331 24.0274 17.3917C23.6488 17.2902 23.3143 17.3331 23.0239 17.5203C22.7434 17.7019 22.5472 18.0013 22.4354 18.4186L21.5409 21.7568Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8812 19.972L13.6989 19.6552L15.7798 11.8892L18.2487 12.5507C18.9442 12.7371 19.5189 13.0029 19.973 13.3482C20.4369 13.6878 20.757 14.1007 20.9332 14.5869C21.1114 15.0653 21.1187 15.6098 20.9552 16.2202C20.7895 16.8384 20.5078 17.3178 20.1101 17.6585C19.7145 17.9915 19.2337 18.1939 18.6678 18.2659C18.1117 18.3322 17.4975 18.2753 16.8252 18.0952L15.1792 17.6542L15.6134 16.5903L17.097 16.9878C17.522 17.1017 17.9124 17.1442 18.268 17.1152C18.6313 17.0883 18.9388 16.9761 19.1905 16.7785C19.4521 16.5753 19.6346 16.2805 19.7381 15.8941C19.8396 15.5155 19.8297 15.1815 19.7084 14.8923C19.5969 14.5974 19.3906 14.3475 19.0893 14.1425C18.7979 13.9319 18.432 13.7676 17.9915 13.6496L16.6701 13.2955L14.8812 19.972Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.76176,
    y: 1.11237,
    width: 71.4958,
    height: 23.76,
    rx: 11.88,
    transform: "rotate(15 6.76176 1.11237)",
    stroke: "url(#paint1_linear_4459_13228)",
    style: {}
  })), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4459_13228",
    x: 0,
    y: 0.5,
    width: 76.4336,
    height: 42.6797,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.456926 0 0 0 0 0.284375 0 0 0 0 0.83372 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4459_13228"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4459_13228",
    x1: 42.6561,
    y1: 0.5,
    x2: 42.6561,
    y2: 25.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231540",
    style: {
      stopColor: "#231540",
      stopColor: "color(display-p3 0.1356 0.0832 0.2500)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463272",
    style: {
      stopColor: "#463272",
      stopColor: "color(display-p3 0.2740 0.1962 0.4457)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4459_13228",
    x1: 34.2056,
    y1: -25.8889,
    x2: 71.731,
    y2: 58.5069,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C80DA",
    style: {
      stopColor: "#9C80DA",
      stopColor: "color(display-p3 0.6122 0.5016 0.8542)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5D33B8",
    style: {
      stopColor: "#5D33B8",
      stopColor: "color(display-p3 0.3636 0.2000 0.7214)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4459_13228"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.4082,
    y: 0.5,
    width: 72.4958,
    height: 24.76,
    rx: 12.38,
    transform: "rotate(15 6.4082 0.5)",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.47e144fcdbb593136d45c040577e59f9.svg";
export { ForwardRef as ReactComponent };